import React from 'react';
import { Link } from 'react-router-dom';

const EligibilityFooter = () => (
  <footer className="elig-foot">
    <div className="container">
      <div>© 2026 SupportCare, Inc. · A Public Benefit Corporation</div>
      <div className="links">
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-conditions">Terms &amp; Conditions</Link>
      </div>
    </div>
  </footer>
);

export default EligibilityFooter;
